import AppPaths from '@globals/paths'
import { colors } from '@globals/themes/defaultTheme'
import { TenantMember } from '@kudos/http-client'
import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import UserAvatar from '@shared/avatar/UserAvatar'
import { T } from '@transifex/react'
import { Link as RouterLink } from 'react-router'

type ViewProfileMenuItemProps = {
  member: TenantMember
  onClose?: () => void
}

const ViewProfileMenuItem: React.FC<ViewProfileMenuItemProps> = ({ member, onClose }) => {
  const { id, avatarUrls, firstName, lastName } = member

  return (
    <MenuItem component={RouterLink} to={AppPaths.tenant.me()} onClick={() => onClose?.()}>
      <Stack direction="row" spacing={2} alignItems="center" overflow="hidden">
        <UserAvatar
          size={36}
          tenantMemberId={id}
          media={avatarUrls}
          firstName={firstName}
          lastName={lastName}
          enableProfilePreview={false}
        />
        <Stack overflow="hidden">
          <Typography variant="h3" noWrap sx={{ mt: { xs: 0 } }}>
            {firstName}
          </Typography>
          <Typography variant="caption" color={colors.bluePrimary}>
            <T _str="View profile" />
          </Typography>
        </Stack>
      </Stack>
    </MenuItem>
  )
}

export default ViewProfileMenuItem
